import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Currency, Locale } from '@rd/types';
import { Subscription } from 'rxjs';
import { getCurrencySelected } from '../../currency/store/selectors/currency.selectors';
import { getLocaleSelected } from '../../locale/store/selectors/locale.selectors';
import { CoreState } from '../../store/reducers';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  currentCurrency$: Subscription;
  currentLocale$: Subscription;

  currentCurrency: Currency | null = null;
  currentLocale: Locale | null = null;

  constructor(private store: Store<CoreState>) {
    this.currentCurrency$ = this.store
      .select(getCurrencySelected)
      .subscribe((currency: Currency | null) => {
        this.currentCurrency = currency;
      });
    this.currentLocale$ = this.store
      .select(getLocaleSelected)
      .subscribe((locale: Locale | null) => {
        this.currentLocale = locale;
      });
  }

  formatCurrency(
    value: number,
    display: string,
    digitsInfo?: string,
    currencyCode?: string,
  ): string {
    const currencyDisplay = this.getCurrencyDisplay(display, currencyCode);

    return this.currentLocale && this.currentCurrency
      ? formatCurrency(
          value,
          this.currentLocale.code,
          currencyDisplay,
          currencyCode || this.currentCurrency.code,
          digitsInfo,
        )
      : '';
  }

  currentCurrencyCode(): string {
    return this.currentCurrency?.code ?? '';
  }

  currentCurrencySymbol(currencyCode?: string): string {
    if (currencyCode) {
      return getCurrencySymbol(currencyCode, 'narrow');
    } else {
      return this.currentCurrency?.symbol ?? '';
    }
  }

  private getCurrencyDisplay(display: string, currencyCode?: string): string {
    switch (display) {
      case 'code': {
        return this.currentCurrency?.code ?? '';
      }
      case 'symbol': {
        return this.currentCurrencySymbol(currencyCode);
      }
      case 'codeWithSpace': {
        return this.currentCurrency ? `${this.currentCurrency.code} ` : ` `;
      }
      default: {
        return display;
      }
    }
  }
}
